import HTTPError from "src/errors/http-error";

export default class IdPError extends HTTPError {}
